
class PaySafe {
	constructor() {
		this.api_key = process.env.VUE_APP_PS_CLIENT_KEY;
		this.api_env = process.env.VUE_APP_PS_CLIENT_ENV;
		this.base_url = process.env.VUE_APP_API_BASE_URL;
	}
	
	getApiKey() {
		return this.api_key;
	}

	getApiEnv() {
		return this.api_env;
	}
}

export default new PaySafe();